import { Button, Flex, Form, Modal, Select } from 'antd'
import { Dispatch, SetStateAction } from 'react'
import { ClientPurseItem } from 'src/views/widgets/groupedClientPurses/types'
import {
  ALL_OPTIONS_STATUS,
  STATUS_THIRD_PARTY_BE,
} from 'src/pages/billing/withdrawals/atoms/EditOwnerTypeModal/const'
import { setPurseOwnerClassification } from 'src/pages/billing/withdrawals/atoms/EditOwnerTypeModal/model'

type Props = {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  purse: ClientPurseItem | null
}
type FormValue = {
  ownerClassificationStatus: string
}

export const EditOwnerTypeModal = ({ purse, open, setOpen }: Props) => {
  const { Item } = Form

  if (!purse) return null

  const options = purse.ownerClassificationStatus
    ? purse.ownerClassificationStatus === STATUS_THIRD_PARTY_BE
      ? [ALL_OPTIONS_STATUS[0]]
      : [ALL_OPTIONS_STATUS[1]]
    : ALL_OPTIONS_STATUS

  const handleCancel = () => {
    setOpen(false)
  }

  const handleSubmit = ({ ownerClassificationStatus }: FormValue) => {
    if (!purse.clientPurseId) return

    setPurseOwnerClassification({
      purseId: purse.clientPurseId,
      ownerClassificationStatus,
    })
    setOpen(false)
  }
  return (
    <Modal
      title={
        <div style={{ fontSize: 20 }}>Set Owner Classification Status</div>
      }
      centered
      wrapClassName="ant_modal"
      width={400}
      maskClosable={false}
      open={open}
      destroyOnHidden
      onCancel={handleCancel}
      footer={null}
    >
      <Form
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={
          options.length < 2
            ? { ownerClassificationStatus: options[0].value }
            : undefined
        }
      >
        <Item
          name="ownerClassificationStatus"
          rules={[
            {
              required: true,
              message: 'Required field',
            },
          ]}
        >
          <Select options={options} />
        </Item>
        <Flex gap={8} justify="flex-end">
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Flex>
      </Form>
    </Modal>
  )
}
